import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import {
    metrics,
    ResponsivePictureLayout,
    TheWestSection,
} from '@news-mono/component-library'
import {
    getResolvedTopicPageMeta,
    StaticRoutes,
    Topic,
} from '@news-mono/web-common'
import { get as getCookie, set as setCookie } from 'js-cookie'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'

export let desktopLandingBanner1x = require('./assets/desktopbanner1220x150.png')
export let desktopLandingBanner2x = require('./assets/desktopbanner2440x300.png')

export let mobileLandingBanner1x = require('./assets/mobilebanner411x93.png')
export let mobileLandingBanner2x = require('./assets/mobilebanner411x93.png')

export let tabletLandingBanner1x = require('./assets/tabletbanner738x57.png')
export let tabletLandingBanner2x = require('./assets/tabletbanner1476x114.png')

export let socialShareImage = require('./assets//BAY Top 50_Social 1200x630.jpg')

export const bestAustralianYarnRoute: StaticRoutes<TheWestSection> = {
    '/lifestyle/best-australian-yarn': ({
        getAdTargeting,
        store,
        config,
        resolution,
    }) => {
        const canonicalUrl =
            config.publicUrl + '/lifestyle/best-australian-yarn'

        const topic: Topic = {
            id:
                getResolvedTopicPageMeta(resolution)?.id ||
                'lifestyle/best-australian-yarn',
            metadata: {},
            title:
                getResolvedTopicPageMeta(resolution)?.title ||
                getResolvedTopicPageMeta(resolution)?.seoTitle ||
                'Best Australian Yarn - Top 50',
            seoTitle: getResolvedTopicPageMeta(resolution)?.seoTitle || '',
            seoDescription:
                getResolvedTopicPageMeta(resolution)?.seoDescription || ``,
        }

        if (
            isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'BAY-top-14',
            )
        ) {
            desktopLandingBanner1x = require('./assets/top14Desktopbanner1220x150.jpg')
            desktopLandingBanner2x = require('./assets/top14Desktopbanner2440x300.jpg')

            mobileLandingBanner1x = require('./assets/top14FeaturesBanner_Mobile_411x93px_@1x.jpg')
            mobileLandingBanner2x = require('./assets/top14FeaturesBanner_Mobile_411x93px_@2x.jpg')

            tabletLandingBanner1x = require('./assets/top14FeaturesBanner_Tablet_738x57px_@1x.jpg')
            tabletLandingBanner2x = require('./assets/top14FeaturesBanner_Tablet_738x57px_@2x.jpg')

            socialShareImage = require('./assets/top14Socialbanner2400x1260CENTERCROP_@2x.jpg')
        }
        const getSocialImageMeta = [
            {
                property: 'og:image',
                content: socialShareImage,
            },
            { name: 'twitter:image', content: socialShareImage },
            {
                property: 'og:image:height',
                content: '643',
            },
            {
                property: 'og:image:width',
                content: '1224',
            },
            {
                property: 'og:description',
                content: topic.seoDescription,
            },
            {
                property: 'twitter:description',
                content: topic.seoDescription,
            },
        ]

        const isEnabled = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'best-australian-yarn-route',
            true,
        )

        const baySeedVal = store.getState().misc.baySeed

        if (
            typeof window !== 'undefined' &&
            baySeedVal &&
            !getCookie('bayseed')
        ) {
            setCookie('bayseed', baySeedVal)
        }

        if (!isEnabled) {
            return null
        }

        return {
            kind: 'page',
            heading: topic.title,
            pageType: 'topic',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                seoTitle: topic.seoTitle,
                seoDescription: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta,
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'image-banner',
                                props: {
                                    defaultSrc: desktopLandingBanner2x,
                                    verticalGutters: ['unset', 'unset'],
                                    altText: 'Best Australian Yarn - Top 50',
                                    sources: [
                                        {
                                            breakpoint: 'md',
                                            src: [
                                                {
                                                    src: desktopLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: desktopLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                        {
                                            breakpoint: 'sm',
                                            src: [
                                                {
                                                    src: tabletLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: tabletLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                        {
                                            src: [
                                                {
                                                    src: mobileLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: mobileLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            }),
                            layout.nestedComposition({
                                type: 'thor',
                                feature:
                                    'best-australian-yarn-curation-segment',
                                props: {
                                    hasBackgroundFill: true,
                                    containerWidth: '100%',
                                    verticalGutters: true,
                                    horizontalGutters: true,
                                    verticalSpacing: 'lg',
                                    themeOverride: 'best-australian-yarn',
                                    hideFeatureHeader: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'sierra',
                                            props: {
                                                verticalSpacing: 'gridGap',
                                                fixedRatios: ['16:9'],
                                                heroImageLayout:
                                                    ResponsivePictureLayout.ObjectFitContain,
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                    maxBreakpoint: 'md',
                                                },
                                                cardLayout: [
                                                    'the-west-hero-lgNoBorder',
                                                    'hero-support',
                                                    'hero-support',
                                                ],
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'best-australian-yarn-feature-page',
                                                    offset: 0,
                                                    pageSize: 3,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                feature: ['BAY-top-14', true],
                                props: {
                                    verticalSpacing: 'xl',
                                    fontScale: 0.75,
                                    fixedRatios: ['16:9'],
                                    hasBackground: true,
                                    kickerMode: 'hidden',
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    cardOrientation: {
                                        type: 'Landscape-Portrait',
                                    },
                                    hideByline: true,
                                    hideBottomBorder: true,
                                    sectionHeader: {
                                        heading: "The Winner's Circle",
                                        section: 'lifestyle',
                                    },
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'best-australian-yarn-feature-page',
                                        offset: 3,
                                        pageSize: 14,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'xl',
                                    fontScale: 0.75,
                                    fixedRatios: ['16:9'],
                                    hasBackground: true,
                                    kickerMode: 'hidden',
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    cardOrientation: {
                                        type: 'Landscape-Portrait',
                                    },
                                    hideByline: true,
                                    hideBottomBorder: true,
                                    sectionHeader: {
                                        heading: 'The Top 50',
                                        section: 'lifestyle',
                                    },
                                    dataDefinitionArgs: {
                                        type: 'listing',
                                        topics: [
                                            'lifestyle/best-australian-yarn/stories',
                                        ],
                                        includeSubTopics: false,
                                        paging: {
                                            page: 1,
                                            pageSize: 50,
                                        },
                                        random: true,
                                        random_offset: 0,
                                        random_size: 50,
                                        seed: baySeedVal,
                                    },
                                },
                            }),
                            ...billboardLeaderboardMrec('one'),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'md',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    loadMoreEnabled: true,
                                    sectionHeader: {
                                        heading: 'Latest News',
                                    },

                                    dataDefinitionArgs: {
                                        type: 'listing',
                                        topics: [
                                            'lifestyle/best-australian-yarn',
                                        ],
                                        includeSubTopics: true,
                                        paging: {
                                            page: 1,
                                            pageSize: 8,
                                            pageOffset: 0,
                                        },
                                    },
                                },
                            }),
                        ],
                        sidebar: [],
                    },
                }),
            ],
        }
    },
}
